export default __webpack_public_path__ + "static/e-faktura-8814c331d19af094d76a6a58ebec63fa.svg";